/* SSR classes */
export const GALLERY_THUMBNAILS_CONTAINER_CLASS = "js-gallery";
export const GALLERY_ITEM_CLASS = "js-gallery-item";

export const LocalizationKeys = {
  CLOSE_TITLE: "galleryClose",
  NEXT_TITLE: "galleryNext",
  PREVIOUS_TITLE: "galleryPrevious",
};

// eslint-disable-next-line no-shadow
export enum ItemDatasetEnum {
  HREF = "href",
  SRCSET = "srcset",
  SIZES = "sizes",
  DESCRIPTION = "subHtml",
  POSTER = "poster",
  SRC = "src",
  IS_VIDEO = "video",
  INDEX_POSITION = "slidePosition",
}

export const SLIDE_TRANSITION_DURATION_MS = 300;
